import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-verified',
  imports: [RouterLink, TranslocoModule],
  templateUrl: './verified.component.html',
})
export class VerifiedComponent {
  @Input() email?: string;
  @Input() scope = 'emailVerification';
}
